import * as UserDAL from '../dal/user-dal'
import * as OrderDAL from '../dal/order-dal'
import { get } from "svelte/store";
import {
    user,
    myOrder,
} from "../stores.js";

export async function initMessaging() {
    let messaging = firebase.messaging();

    if (!messaging) return;

    let _user = get(user);
    if (!_user) return;
    try {
        const token = await messaging.getToken({
            vapidKey:
                window.location.hostname === "localhost" ||
                    window.location.hostname === "pickapp-staging.netlify.app" ||
                    window.location.hostname === "192.168.1.119"
                    ? "BIJcc34K_Zjb7Dsl7rGZkspFs-NOWvfB75vQDizWjShjWfN66c_xkq0Sjq7r5i-IWNd6wPXzgfSKTHmQWaUFou0" //staging FCM Key
                    : "BEidNAnZ9x7LHvKE0XNyJKJVvL58mViaGvCkakYhv-SlwA59mXmPQmpo7tXqZ9l61lUEQ5FKYqUYEVhOG5pA9pc", //prod FCM Key
        });
        if (!token) return null;

        console.log('initMessaging. setting user fcm token:')
        console.log(token)
        user.update((u) => {
            u.fcmToken = token;
            return u;
        });
        messaging.onMessage((payload) => {
            console.log("onMessage: ", payload);
        });
        fcmToken.set(token);


        return token;
    } catch (err) {
        if (err?.code == "messaging/permission-blocked") {
            return null;
        }
        console.log("An error occurred while retrieving token. ", err);
        // setUserFcmToken(false);
        throw err;
    }
}


